import { useState } from "react";
import { Layout, Menu, Button, Drawer } from "antd";
import {
  HomeOutlined,
  AppstoreOutlined,
  UserOutlined,
  MessageOutlined,
  MenuOutlined,
} from "@ant-design/icons";

const { Header: AntHeader } = Layout;

const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const navigationItems = [
    {
      key: "home",
      icon: <HomeOutlined />,
      label: <a href="/#home">Home</a>,
    },
    {
      key: "portfolio",
      icon: <AppstoreOutlined />,
      label: <a href="/#portfolio">Portfolio</a>,
    },
    {
      key: "about",
      icon: <UserOutlined />,
      label: <a href="/#about">About</a>,
    },
    {
      key: "contact",
      icon: <MessageOutlined />,
      label: <a href="/#contact">Contact</a>,
    },
  ];

  return (
    <>
      <AntHeader
        className="site-header"
        style={{
          position: "fixed",
          zIndex: 1000,
          width: "100%",
          background: "#E7DDD3",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 40px",
        }}
      >
        {/* Logo */}
        <div style={{ fontSize: 22, fontWeight: "bold", color: "#916847"}}>
          NOYA
        </div>

        {/* Desktop Menu */}
        <Menu
          className="custom-menu desktop-menu"
          mode="horizontal"
          items={navigationItems}
          style={{ flex: 1, justifyContent: "center", background: "transparent"}}
        />

        {/* Mobile Menu Button */}
        <Button
          className="mobile-menu-button"
          type="text"
          onClick={() => setIsDrawerOpen(true)}
          style={{ color: "#916847"}}
          icon={<MenuOutlined />}
        />
      </AntHeader>

      {/* Mobile Drawer */}
      <Drawer
        title="Menu"
        className="custom-drawer"
        placement="right"
        onClose={() => setIsDrawerOpen(false)}
        open={isDrawerOpen}
      >
        <Menu mode="vertical" items={navigationItems} onClick={() => setIsDrawerOpen(false)} />
      </Drawer>
    </>
  );
};

export default Header;
